import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import ClientNotes from './index';

const ClientNotesWithId = () => {
  const { clientId } = useLocalSearchParams<{ clientId: string }>();

  if (!clientId) {
    return null; // or error handling component
  }

  const clientIdNumber = parseInt(clientId, 10);

  if (isNaN(clientIdNumber)) {
    return null; // or error handling component for invalid ID
  }

  return <ClientNotes clientId={clientIdNumber} />;
};

export default ClientNotesWithId;
